import { Body, CaretSvg, Dropdown, Icon, Spacer } from '@spritz-finance/ui'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import logoSmall from '../../assets/icons/logo.svg'
import { useFeedback } from '../../context/useFeedback'
import { useLogout } from '../../modules/app/auth'
import { Row } from '../Layout/Row'
import { Feature, useFeatureFlag } from '../../context/useFeatureFlag'
import { NewBadge } from '../badges/BadgeContainer'

export const Logo = styled.img`
    height: 34px;
`

const Inner = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`

type MenuItem = {
    title: string
    onClick: () => void
    hidden?: boolean
    new?: boolean
}

export const MobileMenu = () => {
    const { openFeedbackForm } = useFeedback()
    const navigate = useNavigate()
    const { logout } = useLogout()
    const isCardActive = useFeatureFlag(Feature.SpritzCard)

    const options: MenuItem[] = [
        { title: 'Bill pay', onClick: () => navigate('/bills') },
        {
            title: 'Off-ramp',
            onClick: () => navigate('/offramp'),
        },
        { title: 'Spend', onClick: () => navigate('/card'), hidden: !isCardActive, new: true },
        { title: 'Profile', onClick: () => navigate('/profile') },
        {
            title: 'Referrals',
            onClick: () => navigate('/referrals/main'),
        },
        { title: 'Help center', onClick: () => window.open('https://help.spritz.finance/en/') },
        { title: 'Share feedback', onClick: () => openFeedbackForm() },
        { title: 'Sign Out', onClick: logout },
    ].filter(Boolean)

    return (
        <Dropdown.Menu
            minWidth={160}
            align="end"
            offset={5}
            anchor={
                <Inner>
                    <Logo src={logoSmall} />
                    <Icon icon={CaretSvg} size={24} />
                </Inner>
            }
        >
            {options
                .filter((o) => !o.hidden)
                .map((option, index) => {
                    return (
                        <Dropdown.Item onClick={option.onClick} key={index}>
                            <Row align="space-between">
                                <Body.Med>{option.title}</Body.Med>
                                {option.new && (
                                    <>
                                        <Spacer width={8} />
                                        <NewBadge />
                                    </>
                                )}
                            </Row>
                        </Dropdown.Item>
                    )
                })}
        </Dropdown.Menu>
    )
}
